export const API_BASE_URL="https://anshhomoeopathy.in/admin/"
export const Tracking_ID="G-TMP0YQ8DR0"
